/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "zeeshanhshaheen",
  title: "Zeeshan Haider Shaheen",
  subTitle: emoji(
    "A creative Frontend Software Developer 🚀 having experience of building fully responsive Web applications that provide engaging user experience."
  ),
  // resumeLink:
  //   "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/zeeshanhshaheen",
  linkedin: "https://www.linkedin.com/in/zeeshanhshaheen/",
  gmail: "contact@zeeshanhshaheen.com",
  // gitlab: "https://gitlab.com/zeeshanhshaheen",
  facebook: "https://www.facebook.com/zeeshanhshaheen",
  medium: "https://medium.com/@zeeshanhshaheen",
  twitter: "https://twotter.com/zeeshanhshaheen",
  dev: "https://dev.to/zeeshanhshaheen",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "GIVING LIFE TO DESIGNS",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
    ),
    emoji("⚡ Designing UI/UX deisngs using Figma and Adobe XD"),
    emoji(
      "⚡ Integration of third party services such as Firebase / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "DigitalOcean",
      fontAwesomeClassname: "fab fa-digital-ocean"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "NUCES FAST",
      logo: require("./assets/images/fast.png"),
      subHeader: "BS Computer Science",
      duration: "August 2015 - July 2020",
      descBullets: [
        "Major courses like OOP, Data Structures, Web programming",
        "Completed degree in computer science with 130 credit hours."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Design",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Invotyx",
      companylogo: require("./assets/images/invotyx.png"),
      date: "June 2021 – Present",
      descBullets: [
        "Designing and Developing Frontend Features",
        "Fixing bugs in existing applications",
        "Collaborating with backend deveopler to help build applications"
      ]
    },
    {
      role: "Freelance Front-End Developer",
      company: "Fiverr",
      companylogo: require("./assets/images/fiverr.png"),
      date: "August 2019 – Present",
      descBullets: [
        "Creating fully responsive landing pages",
        "Developing Web applications using ReactJS",
        "Turning UI UX Designs into responsive websites",
        "Creating UI designs using Figma"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Octalogix",
      companylogo: require("./assets/images/octalogix.png"),
      date: "August 2019 – March 2021",
      descBullets: [
        "Creating new user features",
        "Developing Web applications using ReactJS",
        "Turning UI UX Designs into responsive websites",
        "Creating UI designs using Figma",
        "Deploying Web applications on DigitalOcean using Nginx and Apache2"
      ]
    }

    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/dev.png"),
      projectName: "DevConnector",
      projectDesc:
        "A social media application where users can create their own account and can share their thoughts by creating a post and commenting on other posts.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://developer-connect1.herokuapp.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/slice.png"),
      projectName: "Sliceline",
      projectDesc:
        "Sliceline is a restaurant app where users can create account and  purchase meals",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://silly-jones-72aef4.netlify.app/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "JavaScript Cirtification(Basic)",
      subtitle: "Completed JavaScript Cirtification on HackerRank",
      image: require("./assets/images/hacker.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.hackerrank.com/certificates/c058b89e87ff"
        }
      ]
    },
    {
      title: "ReactJs Cirtification(Basic)",
      subtitle: "Completed ReactJs Cirtification on HackerRank",
      image: require("./assets/images/hacker.png"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://www.hackerrank.com/certificates/6e443730abb4"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://dev.to/zeeshanhshaheen/how-to-deploy-react-js-and-nodejs-app-on-a-single-digitalocean-droplet-using-nginx-1pcl",
      title:
        "How to deploy ReactJS and Node.js apps on a single DigitalOcean deoplet using Nginx",
      description:
        "In this article, we'll learn how to deploy a React JS app using a simple server block and a Node.js app using reverse proxy server blocks, on a single DigitalOcean droplet using Nginx."
    },
    {
      url: "https://dev.to/zeeshanhshaheen/how-to-host-multiple-wordpress-websites-on-a-single-digitalocean-droplet-using-apache-4i3b",
      title:
        "How to host multiple WordPress websites on a single DigitalOcean droplet using Apache",
      description:
        "In this tutorial, we will learn how to set up WordPress and how to host multiple WordPress websites on a single DigitalOcean droplet using Apache2."
    },
    {
      url: "https://dev.to/zeeshanhshaheen/roadmap-to-learn-and-practice-html-css-javascript-in-6-weeks-27l4",
      title: "Roadmap to learn and practice HTML, CSS & JavaScript in 6 weeks",
      description:
        "It’s never too late to learn code or make a career change in web development. The demand for web developers is high all the time and is still increasing, "
    },
    {
      url: "https://zeeshanhshaheen.medium.com/how-to-create-responsive-layouts-with-flexbox-fb4dc0ce0265",
      title: "How to create responsive layouts with Flexbox",
      description:
        "Flexbox is a relatively new front-end feature that makes building a website layout (and making it responsive!) much, much easier than it used to be. In days past, to build a website, you would have to use "
    },
    {
      url: "https://zeeshanhshaheen.medium.com/what-i-learned-from-mastering-clean-code-in-javascript-course-b0e0ecf2852f",
      title: "What I learned from Mastering Clean Code in JavaScript course",
      description:
        "Writing a clean code is a much-needed skill that every developer should learn. So in this article, I will share my experience that what I have learned after taking the course “Mastering Clean Code in JavaScript” on Udemy."
    },
    {
      url: "https://github.com/zeeshanhshaheen/design-patterns-in-javascript",
      title: " Design Patterns in JavaScript ",
      description:
        "20+ Design Patterns explanation in JavaScript. We will discuss implementation of Design Patterns by using JavaScript ES6 classes."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Have any project ideas to discuss? Let's talk about it!",
  // number: "+92-3243454077",
  email_address: "contact@zeeshanhshaheen.com"
};

// Twitter Section

const twitterDetails = {
  userName: "zeeshanhshaheen", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
